import {
  BottomSheet,
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { Button } from "../../components/Button";

interface WorkerPaySurveySuccessBottomSheetProps {
  modalState: UseModalState;
}

export function WorkerPaySurveySuccessBottomSheet(props: WorkerPaySurveySuccessBottomSheetProps) {
  const { modalState } = props;

  const handleClose = () => {
    modalState.closeModal();
  };

  return (
    <BottomSheet modalState={modalState} header={<BottomSheetHeader onClose={handleClose} />}>
      <DialogContent sx={{ paddingX: 7, paddingTop: 8, paddingBottom: 8 }}>
        <Stack spacing={8} alignItems="center">
          <Illustration type="success" />

          <Title variant="h2" component="h1" sx={{ textAlign: "center", textWrap: "balance" }}>
            Thank you for Participating
          </Title>

          <Text variant="body1" sx={{ textAlign: "center" }}>
            We&apos;ll let you know in ~1 week if you&apos;ve won.
          </Text>

          <Button fullWidth variant="contained" size="large" onClick={handleClose}>
            Browse more shifts
          </Button>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
